export enum GitContentType {
  FILE = 'file',
  DIRECTORY = 'directory',
}
